/* =========================================================
  section-blog.js (main-blog reveal/zoom animation DISABLE)
  - main-blog 内の .observe-me / .is-inview を使う表示時エフェクトを完全停止
  - 代わりに「常に通常表示」に固定（画像が消える事故を防ぐ）
  - Shopify section editor の再読み込み（shopify:section:load）にも対応
========================================================= */

(function () {
  "use strict";

  /**
   * main-blog 内の「表示時エフェクト用クラス」を取り除いて
   * 初期状態（opacity:0 等）に閉じ込められないようにする
   */
  const disableMainBlogReveal = () => {
    const rootSections = document.querySelectorAll(".section-main-blog");
    if (!rootSections || rootSections.length === 0) return;

    rootSections.forEach((section) => {
      // observe-me が付いている要素を全部「素の状態」に戻す
      section.querySelectorAll(".observe-me, .is-inview").forEach((el) => {
        el.classList.remove("observe-me");
        el.classList.remove("is-inview");

        // もし JS が inline style を入れてた場合も保険で解除
        // （テーマによっては transform/opacity を直接入れることがある）
        if (el.style) {
          // transform/opacity だけを狙って消す（他を壊さない）
          if (el.style.transform) el.style.transform = "";
          if (el.style.opacity) el.style.opacity = "";
          if (el.style.visibility) el.style.visibility = "";
          if (el.style.animation) el.style.animation = "";
          if (el.style.transition) el.style.transition = "";
        }
      });
    });
  };

  // 初回実行（ページ読み込み後にDOMができてから）
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", disableMainBlogReveal, { once: true });
  } else {
    disableMainBlogReveal();
  }

  // Shopify テーマエディタでセクション再ロードされた時も適用
  document.addEventListener("shopify:section:load", function () {
    disableMainBlogReveal();
  });

  // load-more / infinite-scroll 等でDOMが追加されるケースに備えて
  // （軽量にしたいので MutationObserver は section-main-blog がある時だけ）
  const attachMutationObserver = () => {
    const sections = document.querySelectorAll(".section-main-blog");
    if (!sections || sections.length === 0) return;

    sections.forEach((section) => {
      const mo = new MutationObserver((mutations) => {
        let needsFix = false;
        for (const m of mutations) {
          if (m.type === "childList" && (m.addedNodes && m.addedNodes.length)) {
            needsFix = true;
            break;
          }
        }
        if (needsFix) disableMainBlogReveal();
      });

      mo.observe(section, { childList: true, subtree: true });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachMutationObserver, { once: true });
  } else {
    attachMutationObserver();
  }
})();

